import {getPageCountryCode} from '@malt/dom';
import {useTranslation} from '@malt/vue3-use';

export function useRemoteLabels() {
    const {msg} = useTranslation();
    const countryCode = getPageCountryCode();

    return {
        remoteCountryLabel: msg(`search.location.remote.${countryCode}`),
    };
}
